// --- Vendors ---
import GLightbox from 'glightbox';


// --- Components ---
const projet = {
    readyFn: function () {
        console.log("projet ready");

        $(".button-show").on("click", function () {
            $(".grid-credit").slideDown();
            $(this).addClass("clicked")
        });

        const lightbox = GLightbox({
            selector: '.glightbox3', // Doit correspondre à la classe ci-dessus
            loop: true,

        });

    }

}
export { projet };